/**
 * Fehler → sichtbare Meldung. Ein Fehler wird **nie** still verschluckt
 * (error-handling.md).
 *
 * Reihenfolge:
 *   1. `VALIDATION_ERROR` / `CONFLICT` — die Servermeldung ist konkreter
 *      (welches Feld, welcher Slug) als jeder generische Text.
 *   2. Sonst der uebersetzte Text zum Fehler-Code.
 *   3. Unbekannte Fehler → generische Meldung.
 *
 * Bekannte Luecke: Servermeldungen aus Fall 1 sind deutsch (siehe TODO.md).
 */
import type { TFunction } from 'i18next';
import { toast } from 'sonner';
import { ApiError } from './api';

const SERVER_MESSAGE_CODES = new Set(['VALIDATION_ERROR', 'CONFLICT']);

export function describeError(error: unknown, t: TFunction): string {
  if (!(error instanceof ApiError)) return t('error.generic');
  if (error.status === 0) return t('error.network');
  if (SERVER_MESSAGE_CODES.has(error.code) && error.message) return error.message;

  const translated = t(`error.code.${error.code}`, { defaultValue: '' });
  return translated.length > 0 ? translated : t('error.generic');
}

/** Zeigt den Fehler als Toast — mit Request-ID, falls der Server eine mitgibt. */
export function toastError(error: unknown, t: TFunction): void {
  const description =
    error instanceof ApiError && error.requestId
      ? t('error.reference', { requestId: error.requestId })
      : undefined;

  toast.error(describeError(error, t), description ? { description } : undefined);
}
